<div class="top-header-right-section flex align-items-center gap-spacing-3xl">
  <z-top-header-filters>
    <div ngProjectAs="filters-section">
      <ng-content select="top-filters-section" />
    </div>
  </z-top-header-filters>
  <div class="notification-section">
    <ng-content select="notification-section" />
  </div>
</div>
